import { useState, useEffect } from 'react';
import useApi from './useApi';

export interface PrecioCopia {
  id: number;
  precio: number;
  color_name: string;
  papel_name: string;
  papel_weight: number;
  hoja_name: string;
  hoja_width: number;
  hoja_height: number;
  faz_name: string;
}

export const usePreciosCopias = () => {
  const [precios, setPrecios] = useState<PrecioCopia[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { getPreciosCopias } = useApi();

  const fetchPrecios = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await getPreciosCopias();
      
      if (response && response.success) {
        setPrecios(response.data);
      } else {
        setError('Error al obtener los precios');
      }
    } catch (err) {
      setError('Error de conexión');
      console.error('Error fetching precios:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrecios();
  }, []);

  const refreshPrecios = () => {
    fetchPrecios();
  };

  return {
    precios,
    loading,
    error,
    refreshPrecios
  };
};
